export default __webpack_public_path__ + "static/media/6.fb05aa7e.webp";